import React, { Component } from 'react'
import { Button, Form, Input, Icon, Divider, Spin, message, Checkbox  } from 'antd';
import { Link } from 'react-router-dom';
const FormItem = Form.Item;

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: ''
    };
  }

  handleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  componentWillReceiveProps(nextProps) {
    const { authError, authSuccess,role,uid, loading } = nextProps.localAuth;
   
    // if (authError && !loading)  console.log(authError)
    // message.error(authError);
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFields((err) => {
      if (!err) {
        this.props.signIn(this.state);
      }
    });
  }  
  
  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.props.localAuth;
    return (
      <div className="loginmodal">
        <Spin indicator={<Icon type="loading" style={{ fontSize: 60 }} spin /> } spinning={loading}>
          <Form onSubmit={e => this.handleSubmit(e)}>
          <div className="xheader">
            <img src="../../img/logo.png" />
                  <h5>Login to your account</h5>
                  </div>
            <FormItem>
            {getFieldDecorator('email', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your email'
                  },
                  {
                    type: 'email',
                    message: 'The input is not valid email'
                  }
                ]
              })(
                <Input
                  onChange={e => this.handleChange(e)}
                  prefix={
                    <Icon
                      type="mail"
                      style={{ color: 'rgba(0,0,0,.25)' }}
                    />
                  }
                  name="email"
                  placeholder="Email Address"
                />
              )}
            </FormItem>
            <FormItem style={{margin:0}}>
              {getFieldDecorator('password', {
                rules: [
                  {
                    required: true,
                    message: 'Please input your password'
                  }
                ]
              })(
                <Input.Password
                  onChange={e => this.handleChange(e)}
                  prefix={
                    <Icon
                      type="lock"
                      style={{ color: 'rgba(0,0,0,.25)' }}
                    />
                  }
                  type="password"
                  name="password"
                  placeholder="Password"
                />
              )}
            </FormItem>
            <Form.Item style={{margin:0}}>
                    {getFieldDecorator('remember', {
                        valuePropName: 'checked',
                        initialValue: true,
                    })(<Checkbox>Remember me</Checkbox>)}
                    </Form.Item>
            <FormItem>
              <Button
                block
                type="primary"
                htmlType="submit"
                className="xpad-btn"
              >
                LOGIN
              </Button>
            </FormItem>
            <div className="form-lower">
              <Divider style={{margin:"0 0 10px"}}/>
              <center className="text">
                Forgot password? <Link to="/forgot-password">Click here</Link>
              <br />  Don't have an account? <Link to="/signup" className="link">Signup</Link>{' '}

              </center>
            </div>
          </Form>
        </Spin>
      </div>
    )
  }
}

const WrappedLoginModal = Form.create()(LoginModal);
export default WrappedLoginModal;
